import { Fragment, useState } from 'react'
import { getBelongsToTitle } from '../account/booking-details/helpers'
import InclusionRow from './InclusionRow'
import InclusionsTable from './InclusionsTable'
import OffestDetailsPopup from './OffestDetailsPopup'
import { sectionWithoutMandatoryOrIncluded } from './ResortGuestInclusions'

export default function InclusionsSection({ fields }) {
  const [isVisible, setVisible] = useState(false)
  const closePopup = () => setVisible(false)
  const showOffsetProductDetails = () => setVisible(true)
  return (
    <Fragment>
      <OffestDetailsPopup isVisible={isVisible} onClose={closePopup} />
      {fields.map((field, index) => {
        const value = fields.value[index]
        const items = sectionWithoutMandatoryOrIncluded(value)
        if(!items.length) {
          return null
        }
        const incl = value[0]
        return (
          <div className='inclusions-section' key={index}>
            <h3 className='section-title'>
              <i
                className={`icon font-icons ${
                  incl.isTransfer ? 'icon-transfer' : 'icon-surcharges'
                }`}
              />
              {getBelongsToTitle(incl.belongsTo)}
            </h3>
            <InclusionsTable>
              {value.map((item, index) => (
                <InclusionRow
                  key={item.pricingId}
                  name={`${field}[${index}]`}
                  item={item}
                  showDetailsPopup={showOffsetProductDetails}
                />
              ))}
            </InclusionsTable>
          </div>
        )
      })}
    </Fragment>
  )
}
